export enum DatabasesIndexType {
    Key = 'key',
    Fulltext = 'fulltext',
    Unique = 'unique',
    Spatial = 'spatial',
    Trigram = 'trigram',
}
